<template>
  <div class="h5-group-page-course-card">
    <img
      class="cover"
      :src="courseInfo.cover_url + '?imageView2/0/w/300'"
      alt=""
    />
    <div class="coure-info">
      <p class="title">
        {{ courseInfo.course_name }}
      </p>
      <Price
        size="ML2"
        :activePrice="activeInfo.group_price"
        :originPrice="courseInfo.goods?.price"
      />
    </div>
  </div>
</template>

<script>
import { Price } from "@saas/components/src";
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    activeInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {};
  },
  components: {
    Price,
  },
};
</script>

<style lang="scss" scoped>
.h5-group-page-course-card {
  margin: 0 auto;
  display: flex;
  align-items: center;
  width: 8.72rem;
  height: 2.88rem;
  border-radius: 0.32rem;
  border: 0.01rem solid #ffced4;
  padding: 0.32rem 0.27rem 0.32rem 0.32rem;
  background: #fff;
  .cover {
    width: 4rem;
    height: 2.24rem;
    border-radius: 0.24rem;
    margin-right: 0.25rem;
    object-fit: cover;
  }
  .coure-info {
    flex: 1;
    width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-weight: 500;
      font-size: 0.43rem;
      color: #0d1400;
      line-height: 0.6rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .price-wrap {
    display: flex;
    align-items: end;
  }
  ::v-deep .active-price {
    color: #ff265c;
    line-height: 0.59rem;
    font-weight: 800;
    margin-right: 0.1rem;
    .unit {
      font-size: 0.35rem;
    }
    .integer {
      font-size: 0.48rem;
    }
    .decimal {
      font-size: 0.35rem;
    }
  }
  .origin-price {
    line-height: 0.59rem;
    text-decoration-line: line-through;
    font-weight: 500;
    font-size: 0.32rem;
    color: #747573;
  }
}
</style>
